"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("@material-ui/core/Button");
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = require("classnames");
const React = require("react");
const PaginationStyle_1 = require("./jss/PaginationStyle");
class Pagination extends React.Component {
    constructor() {
        super(...arguments);
        this.updateActivePage = (currentPage) => () => {
            if (currentPage === this.props.activePage) {
                return;
            }
            if (this.props.scrollToTopOnChange) {
                this.scrollToTop();
            }
            this.props.onSelect(currentPage, this.props.size);
        };
        this.scrollToTop = () => {
            if (window.scrollY > 250) {
                window.scrollTo(0, 0);
            }
        };
        this.previousPage = () => {
            if (this.props.first) {
                return;
            }
            if (this.props.scrollToTopOnChange) {
                this.scrollToTop();
            }
            this.props.onSelect(this.props.activePage - 1, this.props.size);
        };
        this.nextPage = () => {
            if (this.props.last) {
                return;
            }
            if (this.props.scrollToTopOnChange) {
                this.scrollToTop();
            }
            this.props.onSelect(this.props.activePage + 1, this.props.size);
        };
        this.onEllipsis = (index) => {
            const { activePage, totalPages, maxButtons, scrollToTopOnChange } = this.props;
            const total = totalPages !== null && totalPages !== void 0 ? totalPages : 0;
            let page = activePage > index ? activePage - maxButtons : activePage + maxButtons;
            if (page < 0) {
                page = 0;
            }
            else if (page >= total && total > 0) {
                page = total + 1 - maxButtons;
            }
            if (scrollToTopOnChange) {
                this.scrollToTop();
            }
            this.props.onSelect(page, this.props.size);
        };
        this.renderPaginationItems = (index) => {
            const paginationLink = (0, classnames_1.default)({
                [this.props.classes.paginationLink]: true,
                [this.props.activeBtnColor
                    ? this.props.classes[this.props.activeBtnColor]
                    : this.props.classes.primary]: index === this.props.activePage,
                [this.props.buttonStyle]: index !== this.props.activePage
            });
            return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: this.props.classes.paginationItem }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: this.updateActivePage(index), className: paginationLink, "aria-label": 'Goto Page ' + (index + 1), "aria-current": index === this.props.activePage }, { children: index + 1 })) }), `page_${index}`));
        };
        this.renderActivityPageNumber = (index) => {
            const paginationLink = (0, classnames_1.default)({
                [this.props.classes.paginationLink]: true
            });
            return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: this.props.classes.paginationItem }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: this.updateActivePage(index), className: paginationLink, "aria-label": 'Goto Page ' + (index + 1), "aria-current": index === this.props.activePage }, { children: index + 1 })) }), `page_${index}`));
        };
        this.displayPaginationItems = () => {
            const { totalPages, maxButtons, activePage, marginPagesDisplayed, breaks, hidePaginationNumbers, activityHistory } = this.props;
            const items = [];
            if (activityHistory) {
                items.push(this.renderActivityPageNumber(activePage));
            }
            else {
                if (!totalPages || hidePaginationNumbers) {
                    return null;
                }
                if (totalPages <= maxButtons) {
                    for (let index = 0; index < totalPages; index++) {
                        items.push(this.renderPaginationItems(index));
                    }
                }
                else {
                    let leftSide = maxButtons / 2;
                    let rightSide = maxButtons - leftSide;
                    if (activePage > totalPages - maxButtons / 2) {
                        rightSide = totalPages - activePage;
                        leftSide = maxButtons - rightSide;
                    }
                    else if (activePage < maxButtons / 2) {
                        leftSide = activePage;
                        rightSide = maxButtons - leftSide;
                    }
                    let index;
                    let page;
                    let breakView = null;
                    for (index = 0; index < totalPages; index++) {
                        page = index + 1;
                        if (page <= marginPagesDisplayed) {
                            items.push(this.renderPaginationItems(index));
                            continue;
                        }
                        if (page > totalPages - marginPagesDisplayed) {
                            items.push(this.renderPaginationItems(index));
                            continue;
                        }
                        if (index >= activePage - leftSide && index <= activePage + rightSide) {
                            items.push(this.renderPaginationItems(index));
                            continue;
                        }
                        if (breaks && items[items.length - 1] !== breakView) {
                            const paginationLink = (0, classnames_1.default)({
                                [this.props.classes.paginationLink]: true,
                                [this.props.activeBtnColor
                                    ? this.props.classes[this.props.activeBtnColor]
                                    : this.props.classes.primary]: index === this.props.activePage
                            });
                            breakView = ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: this.props.classes.paginationItem }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: this.onEllipsis.bind(this, index), className: (0, classnames_1.default)(paginationLink, this.props.buttonStyle), "aria-label": 'Goto Page ' + (index + 1), "aria-current": index === this.props.activePage }, { children: "..." })) }), `page_ellipsis_${index}`));
                            items.push(breakView);
                        }
                    }
                }
            }
            return items;
        };
    }
    render() {
        const { first, last, classes, className, buttonStyle } = this.props;
        const paginationClasses = (0, classnames_1.default)(classes.pagination, className);
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { alignSelf: 'center', marginTop: 16, marginBottom: 16 } }, { children: (0, jsx_runtime_1.jsx)("nav", Object.assign({ role: "navigation", "aria-label": "Pagination Navigation" }, { children: (0, jsx_runtime_1.jsxs)("ul", Object.assign({ className: paginationClasses }, { children: [(0, jsx_runtime_1.jsx)("li", Object.assign({ className: classes.paginationItem }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: this.previousPage, disabled: first, className: (0, classnames_1.default)(classes.paginationLink, buttonStyle), "aria-label": "Goto Previous page" }, { children: "Prev" })) })), this.displayPaginationItems(), (0, jsx_runtime_1.jsx)("li", Object.assign({ className: classes.paginationItem }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: this.nextPage, className: (0, classnames_1.default)(classes.paginationLink, buttonStyle), "aria-label": "Goto Next page", disabled: last }, { children: "Next" })) }))] })) })) })));
    }
}
Pagination.defaultProps = {
    scrollToTopOnChange: false
};
exports.default = (0, styles_1.withStyles)(PaginationStyle_1.default)(Pagination);
//# sourceMappingURL=Pagination.js.map